import React from "react";
import { Marker } from "pigeon-maps";

interface PostMarkerProps {
  onClick: () => void;
  onMouseOver: () => void;
  onMouseOut: () => void;
  isSelected: boolean;
  anchor: [number, number];
  title: string;
  isCategoryOrTagSelected: boolean;
  isActive: boolean;
}

const PostMarker: React.FC<PostMarkerProps> = ({ onClick, onMouseOver, onMouseOut, title, isCategoryOrTagSelected, isActive, isSelected, anchor }) => {
  const iconSrc = `../../../images/icons/marker.svg`;
  const size = isCategoryOrTagSelected ? 24 : 16;

  return (
    <img
      src={iconSrc}
      anchor={anchor}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      width={size}
      color={'black'}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        position: "absolute",
        top: `-0px`,
        left: `-0px`,
        cursor: "pointer",
        pointerEvents: "auto",
        filter: isActive ? "drop-shadow(0px -1px 4px #FF9000) drop-shadow(0px -1px 4px #FF9000)" : "none",
        zIndex: "5",
      }}
    />
  );
};

export default PostMarker;